import { Component, OnInit, OnDestroy, Directive, Input, HostListener, ViewChild, ViewEncapsulation, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, NgControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { CognitoUtil } from '../../../../shared/services/cognito.service';
import { CaseService } from '../../../../shared/services/case.service';
import { Case } from '../../../../shared/models/case';
import { AlertService } from '../../../../shared/services/alert.service';
import { Alert } from '../../../../shared/models/alert';
import 'rxjs/Rx';
import { CommentService } from '../../../../shared/services/comment.service';
import { UserService } from '../../../../shared/services/user.service';
import { LocalUserService } from '../../../../shared/services/localUser';
import { PreSignService } from '../../../../shared/services/preSign.service';
import * as _ from 'lodash';

@Component({
  selector: 'openAlert',
  templateUrl: './openAlert.component.html',
  providers: [
    AlertService,
    CommentService,
    LocalUserService,
    PreSignService
  ],
  styleUrls: ['./openAlert.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OpenAlertComponent implements OnInit {
  hideUploadFileButton = false;

  isFileLoading = false;

  dialogTitle: String
  userId: string;
  orgId: string;
  caseId: string;

  alert: any;
  alertId: string;

  userName = '';

  files = [];
  caseNumber: '';

  guardianName: string;

  wardName: string;

  caseLastModified: Date;

  selectedTab = 'alertInfo'

  displayedColumns: string[] = ['file', 'fileSize', 'Link'];
  loading: any = false;

  constructor(
    public dialogRef: MatDialogRef<OpenAlertComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private formBuilder: FormBuilder,
    private cognitoUtil: CognitoUtil,
    private router: Router,
    private alertService: AlertService,
    private caseService: CaseService,
    private commentService: CommentService,
    private userService: UserService,
    private localUser: LocalUserService,
    private preSignService: PreSignService
  ) {
    this.caseId = this.data.alert.case_id;
    if(this.caseId) {
      this.caseService.getCaseById('', this.caseId)
          .subscribe(data => {
            this.orgId = data.summary.organization_id;
          }, Error => {
            console.log(Error);
          });
    }
    this.alert = this.data.alert;
    this.alertId = this.data.alert.id;
    this.caseNumber = this.data.alert.case_number;
  }

  ngOnInit() {
    // this.orgId = this.localUser.getOrganizationId();
    this.userId = this.localUser.getUserId();
    this.dialogTitle = this.alert.subject;
    setTimeout(() => {
      this.alertOpened();
      this.getFiles();
      this.getUserName();
    }, 3000);
  }

  getFiles() {
    this.files = [];
    this.isFileLoading = true;
    this.preSignService.getListForAlert(this.orgId, this.caseId, this.alertId)
      .subscribe(result => {
        this.files = _.filter(result, ['disposition', 'attachment']);
        this.isFileLoading = false;
      });
  }

  upload(event) {
    this.isFileLoading = true;
    if (event.target.files.length === 0) {
      return 0;
    }

    let file = event.target.files[0];

    this.preSignService.getPresignForAlert(this.orgId, this.caseId, this.alertId, file.name)
      .subscribe(result => {
        this.preSignService.uploadFile(result, file)
          .subscribe(resultt => {
            this.isFileLoading = false;
            this.getFiles();
          });
      });


  }

  alertOpened() {
    this.alertService.alertViewed(this.orgId, this.caseId, this.alertId, null)
      .subscribe(result => {
        this.guardianName = result.guardian_name;
        this.wardName = result.ward_name;
        this.caseLastModified = result.case_last_modified;
      });
  }

  closeAlert() {
    this.loading = true;
    this.alertService.closeAlert(this.orgId, this.caseId, this.alertId, null)
      .subscribe(result => {
        this.loading = false;
        this.dialogRef.close(true);
      });
  }

  postComment() {

    let data = {
      id: null,
      user_id: this.userId,
      organization_id: this.orgId,
      comment_for_id: this.alertId,
      commented_at: new Date(),
      type: 'ALERT_COMMENT',
      message: ''
    };

  }

  getUserName() {
    this.userService.getUser(this.alert.sent_by)
      .subscribe(result => {

        if (result.first_name === null) {
          this.userName = 'No Name Listed';
        }
        else {
          this.userName = result.first_name;
        }

        if (result.last_name !== null) {
          this.userName = result.first_name + ' ' + result.last_name;
        }

      });
  }

  cleanFileSize(size) {

    size = size / 1024;
    if (size > 1024) {
      size = size / 1024;
      return size.toFixed(2) + 'MB';
    }
    else {
      return size.toFixed(2) + 'KB';
    }

  }

  formatTime(unix) {
    let theDate = new Date(unix);

    let options = { hour12: true, hour: 'numeric', minute: 'numeric', month: 'numeric', day: 'numeric', year: 'numeric' };

    return theDate.toLocaleDateString('en-US', options);
  }

  chartTabChange(event) {
    if (event.index === 0) {
      this.hideUploadFileButton = true;
    } else {
      this.hideUploadFileButton = false;
    }
  }

  openCase() {

    this.dialogRef.close();
    this.router.navigate(['case', this.orgId, this.caseId]);
  }

  getCaseNumber() {
    return (this.caseNumber) ? this.caseNumber : 'Open Case';
  }

}








// WEBPACK FOOTER //
// ./src/app/main/content/common/alertList/openAlert/openAlert.component.ts